export const JYNTIX_URL = "https://jyntix.net";

export type JyntixProduct = {
  name: string;
  url: string;
  descriptionEn: string;
  descriptionTr: string;
};

export const JYNTIX_PRODUCTS: readonly JyntixProduct[] = [
  {
    name: "INTEGLY",
    url: "https://jyntix.net/integly",
    descriptionEn:
      "Cloud-native integration, transformation and orchestration with real-time monitoring.",
    descriptionTr:
      "Bulut tabanlı entegrasyon, dönüşüm ve orkestrasyon ile gerçek zamanlı izleme.",
  },
  {
    name: "AI DEVGUI",
    url: "https://jyntix.net/ai-devgui",
    descriptionEn: "AI-assisted development tooling for enterprise software teams.",
    descriptionTr: "Kurumsal yazılım ekipleri için yapay zekâ destekli geliştirme araçları.",
  },
  {
    name: "AI IDOCMON",
    url: "https://jyntix.net/ai-idocmon",
    descriptionEn: "AI-supported SAP IDoc monitoring and analysis.",
    descriptionTr: "Yapay zekâ destekli SAP IDoc izleme ve analiz.",
  },
  {
    name: "E-GOVERNMENT",
    url: "https://jyntix.net/e-government",
    descriptionEn: "Digital governance solutions for enterprise and public-sector processes.",
    descriptionTr: "Kurumsal ve kamu süreçleri için dijital yönetişim çözümleri.",
  },
];

export const jyntixNavLink = {
  href: JYNTIX_URL,
  label: "JYNTIX — an OXORY brand",
} as const;

export const jyntixNavLinkTr = {
  href: JYNTIX_URL,
  label: "JYNTIX — bir OXORY markası",
} as const;

export const integlyNavLink = {
  href: "https://jyntix.net/integly",
  label: "INTEGLY — integration platform",
} as const;

export const integlyNavLinkTr = {
  href: "https://jyntix.net/integly",
  label: "INTEGLY — entegrasyon platformu",
} as const;